export const homepage = {
  // Hero Section
  heroTitle: 'اعثر على سيارتك المثالية للإيجار',
  heroSubtitle: 'استكشف عالماً من الإمكانيات اللامحدودة مع منصتنا المتطورة لتأجير السيارات. اتصل بآلاف الوكالات المعتمدة حول العالم، واستمتع بتجربة حجز سلسة وأسعار تنافسية ومركبات فاخرة تجعل كل رحلة لا تُنسى وخالية من الإجهاد.',
  searchCars: 'البحث عن السيارات',
  findBookRental: 'ابحث، احجز، واستأجر سيارة في',
  easySteps: 'خطوات سهلة.',
  getCarWherever: 'احصل على سيارة أينما وكلما احتجتها مع خدمة مهنية وأسعار تنافسية.',
  
  // Search Form
  location: 'الموقع',
  pickupDate: 'تاريخ الاستلام',
  returnDate: 'تاريخ الإرجاع',
  
  // Steps Section
  rentWithSteps: 'استأجر باتباع هذه الخطوات الثلاث',
  chooseLocation: 'اختر الموقع',
  chooseLocationDesc: 'اختر موقعك واعثر على أفضل سيارة لك',
  pickupDateDesc: 'حدد تاريخ ووقت الاستلام لحجز سيارتك',
  bookYourCar: 'احجز سيارتك',
  bookYourCarDesc: 'احجز سيارتك وسنوصلها إليك مباشرة',
  
  // Features
  whyChooseKiraCar: 'لماذا تختار كيرا كار؟',
  whyChooseSubtitle: 'اختبر أفضل خدمة تأجير سيارات مع وكالاتنا المعتمدة ودعم العملاء الاستثنائي.',
  verifiedAgencies: 'وكالات معتمدة',
  verifiedAgenciesDesc: 'جميع وكالات التأجير معتمدة بعناية لضمان سلامتك وراحة بالك.',
  support247: 'دعم 24/7',
  support247Desc: 'دعم العملاء على مدار الساعة لمساعدتك كلما احتجت المساعدة.',
  bestPrices: 'أفضل الأسعار',
  bestPricesDesc: 'قارن الأسعار من عدة وكالات للعثور على أفضل عروض تأجير السيارات.',
  trustedReviews: 'تقييمات موثوقة',
  trustedReviewsDesc: 'اقرأ تقييمات حقيقية من عملاء معتمدين لاتخاذ قرارات مدروسة.',
  
  // Sections
  featuredCars: 'السيارات المميزة',
  featuredCarsDesc: 'اكتشف سيارات التأجير الأكثر شعبية من وكالات موثوقة.',
  trustedAgencies: 'وكالات موثوقة',
  trustedAgenciesDesc: 'شراكة مع أكثر وكالات تأجير السيارات موثوقية في العالم.',
  viewAllCars: 'عرض جميع السيارات',
  
  // CTA
  readyToStart: 'مستعد لبدء رحلتك؟',
  readyToStartDesc: 'انضم إلى آلاف العملاء الراضين واعثر على سيارة التأجير المثالية اليوم.',
  browseCars: 'تصفح السيارات',
  joinAsAgency: 'انضم كوكالة',
  
  // Footer
  quickLinks: 'روابط سريعة',
  forAgencies: 'للوكالات',
  agencyHelp: 'مساعدة الوكالات',
  termsOfService: 'شروط الخدمة',
  privacyPolicy: 'سياسة الخصوصية',
  allRightsReserved: 'جميع الحقوق محفوظة',
}; 